import { getInitialState } from './reducer';
import { createSelector } from 'reselect';
export var selectSelectedApp = function (state) {
    return (state && state.selectedApp) || getInitialState();
};
export var makeSelectSelectedApp = function () {
    return createSelector(selectSelectedApp, function (selectedApp) { return selectedApp.app; });
};
